import { useState } from 'react';
import jsPDF from 'jspdf';
import QRCode from 'qrcode';
import { toast } from 'react-toastify';

function useManageLabel() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateLabelPDF = async (shipDateId, startNo, endNo, shipDateInfo) => {
    setIsLoading(true);
    let result = true;
    try {
      const pdf = new jsPDF({
        orientation: 'landscape', // Landscape for 60x40mm
        unit: 'mm',
        format: [60, 40] // Label size: 60mm width, 40mm height
      });

      const start = parseInt(startNo);
      const end = parseInt(endNo);
      const totalLabels = end - start + 1;

      for (let i = 0; i < totalLabels; i++) {
        const boxNo = start + i;
        
        // Generate simple QR code data: "2025-10-19_4"
        const qrData = `${shipDateInfo.shipDate}_${boxNo}`;

        // Generate QR code as data URL
        const qrCodeDataURL = await QRCode.toDataURL(qrData, {
          width: 80,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          },
          errorCorrectionLevel: 'M'
        });

        // Add new page for each label (except the first one)
        if (i > 0) {
          pdf.addPage();
        }

        // Add QR code to PDF (top left, 20x20mm)
        pdf.addImage(qrCodeDataURL, 'PNG', 5, 2, 20, 20);

        // Add ship date text (below QR code)
        pdf.setFontSize(11);
        pdf.text(`${shipDateInfo.shipDate}`, 29, 5.5);

        // Add box number (right side, as big as possible for 3 digits)
        pdf.setFontSize(50); // Large font for box number
        pdf.text(`${boxNo}`, 26, 22); // Right side, centered vertically
        
        // Add rectangle under the box number
        pdf.setDrawColor(0, 0, 0); // Black border
        pdf.setLineWidth(0.5); // Thin line
        pdf.rect(5, 25.5, 42, 12); // Rectangle: x, y, width, height

        pdf.setFontSize(20); // Large font for box number
        pdf.text(`kg`, 49, 34); // Right side, centered vertically
      }

      // Open PDF in new tab for preview
      const pdfBlob = pdf.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, '_blank');
      toast.success(`PDF preview opened! ${totalLabels} labels created.`);
      
      return true;
    } catch (err) {
      result = false;
      console.log(err);
      setError('An error occurred while generating PDF.');
      toast.error("Failed to generate PDF");
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  return {
    isLoading,
    error,
    generateLabelPDF
  };
}

export default useManageLabel;
